/**
 * RAKK — Protection Post-Livraison Upsell v3
 * - sessionStorage pour mémoriser le refus utilisateur
 * - anti-doublon : une seule ligne protection à la fois
 * - masquage de l'item dans la liste du drawer
 */
(function () {
  'use strict';

  var PROTECTION_VARIANTS = [
    { min: 10000,     max: 12500,       variantId: 56855736975738,  price: 300  },
    { min: 12500,     max: 15000,       variantId: 56855737008506,  price: 350  },
    { min: 15000,     max: 17500,       variantId: 56855737041274,  price: 400  },
    { min: 17500,     max: 20000,       variantId: 56855737074042,  price: 450  },
    { min: 20000,     max: 25000,       variantId: 56855737106810,  price: 550  },
    { min: 25000,     max: 30000,       variantId: 56855737139578,  price: 700  },
    { min: 30000,     max: 35000,       variantId: 56855737172346,  price: 800  },
    { min: 35000,     max: 40000,       variantId: 56855737205114,  price: 950  },
    { min: 40000,     max: 45000,       variantId: 56855737237882,  price: 1050  },
    { min: 45000,     max: 50000,       variantId: 56855737270650,  price: 1200  },
    { min: 50000,     max: 60000,       variantId: 56855737303418,  price: 1400  },
    { min: 60000,     max: 70000,       variantId: 56855737336186,  price: 1600  },
    { min: 70000,     max: 80000,       variantId: 56855737368954,  price: 1900  },
    { min: 80000,     max: 90000,       variantId: 56855737401722,  price: 2100  },
    { min: 90000,     max: 100000,      variantId: 56855737434490,  price: 2400  },
    { min: 100000,    max: 120000,      variantId: 56855737467258,  price: 2750  },
    { min: 120000,    max: 140000,      variantId: 56855737500026,  price: 3250  },
    { min: 140000,    max: 160000,      variantId: 56855737532794,  price: 3750  },
    { min: 160000,    max: 180000,      variantId: 56855737565562,  price: 4250  },
    { min: 180000,    max: 200000,      variantId: 56855737598330,  price: 4750  },
    { min: 200000,    max: 250000,      variantId: 56855737631098,  price: 5600  },
    { min: 250000,    max: 300000,      variantId: 56855737663866,  price: 6900  },
    { min: 300000,    max: 350000,      variantId: 56855737696634,  price: 8100  },
    { min: 350000,    max: 400000,      variantId: 56855737729402,  price: 9400  },
    { min: 400000,    max: 500000,      variantId: 56855737762170,  price: 11250  },
    { min: 500000,    max: 600000,      variantId: 56855737794938,  price: 13750  },
    { min: 600000,    max: 700000,      variantId: 56855737827706,  price: 16250  },
    { min: 700000,    max: 800000,      variantId: 56855737860474,  price: 18750  },
    { min: 800000,    max: 1000000,     variantId: 56855737893242,  price: 22500  },
    { min: 1000000,   max: 1200000,     variantId: 56855737926010,  price: 27500  },
    { min: 1200000,   max: Infinity,    variantId: 56855737958778,  price: 31500  },
  ];

  var ALL_VARIANT_IDS = PROTECTION_VARIANTS.map(function(v) { return v.variantId; });
  var SESSION_KEY = 'rakk_protection_declined';

  function isDeclined() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch(e) { return false; }
  }
  function setDeclined(val) {
    try { sessionStorage.setItem(SESSION_KEY, val ? '1' : '0'); } catch(e) {}
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function getVariantForTotal(totalCents) {
    for (var i = 0; i < PROTECTION_VARIANTS.length; i++) {
      var v = PROTECTION_VARIANTS[i];
      if (totalCents >= v.min && totalCents < v.max) return v;
    }
    return null;
  }

  function isProtectionItem(item) {
    return ALL_VARIANT_IDS.indexOf(item.variant_id) !== -1;
  }

  // ─── API Cart ─────────────────────────────────────────────────

  function cartPost(endpoint, body) {
    return fetch(window.Shopify.routes.root + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  function addProtection(variantId) {
    return cartPost('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
  }

  function removeByKey(key) {
    return cartPost('cart/change.js', { id: key, quantity: 0 });
  }

  /**
   * Supprime TOUTES les lignes protection sauf éventuellement celle à garder,
   * puis appelle le callback avec la ligne survivante (ou null).
   * Anti-doublon central.
   */
  function deduplicateProtection(cart, keepKey, cb) {
    var protectionItems = cart.items.filter(isProtectionItem);

    if (protectionItems.length === 0) { cb(null); return; }
    if (protectionItems.length === 1) { cb(protectionItems[0]); return; }

    // Plusieurs lignes → on garde celle dont la clé = keepKey (ou la première), on retire les autres
    var toKeep = keepKey
      ? protectionItems.find(function(i) { return i.key === keepKey; }) || protectionItems[0]
      : protectionItems[0];
    var toRemove = protectionItems.filter(function(i) { return i.key !== toKeep.key; });

    var chain = Promise.resolve();
    toRemove.forEach(function(item) {
      chain = chain.then(function() { return removeByKey(item.key); });
    });
    chain.then(function() { cb(toKeep); });
  }

  // ─── DOM ─────────────────────────────────────────────────────

  var widget = null;
  var busy = false;

  function getWidget() {
    if (!widget || !document.body.contains(widget)) {
      widget = document.getElementById('rakk-protection-upsell');
    }
    return widget;
  }

  function updatePrice(price) {
    var el = document.getElementById('rakk-protection-price');
    if (el) el.textContent = formatMoney(price);
  }

  function setToggle(checked) {
    var t = document.getElementById('rakk-protection-toggle');
    if (t) t.checked = checked;
  }

  function showWidget() {
    var w = getWidget();
    if (w) { w.classList.remove('rakk-protection-upsell--hidden'); w.setAttribute('aria-hidden','false'); }
  }

  function hideWidget() {
    var w = getWidget();
    if (w) { w.classList.add('rakk-protection-upsell--hidden'); w.setAttribute('aria-hidden','true'); }
  }

  // ─── Masquer l'item dans la liste du drawer ───────────────────

  var cssInjected = false;
  function injectHideCSS() {
    if (cssInjected) return;
    cssInjected = true;
    var style = document.createElement('style');
    style.id = 'rakk-hide-protection-item';
    style.textContent = [
      '.cart-item.product-protection-post-livraison-rakk { display: none !important; }',
      '.cart-item.product-protection-post-livraison { display: none !important; }'
    ].join('\n');
    document.head.appendChild(style);
  }

  function hideProtectionInList(cart) {
    cart.items.forEach(function (item) {
      if (!isProtectionItem(item)) return;
      var node = document.querySelector('.cart-item[data-key="' + item.key + '"]');
      if (node) node.style.display = 'none';
    });
  }

  // ─── Sync principal ───────────────────────────────────────────

  function syncWidget() {
    if (busy) return;
    busy = true;

    getCart().then(function (cart) {
      // 1. Calculer le sous-total hors protection
      var subtotal = 0;
      cart.items.forEach(function (item) {
        if (!isProtectionItem(item)) subtotal += item.final_line_price;
      });

      // 2. Masquer dans la liste
      hideProtectionInList(cart);

      var targetVariant = getVariantForTotal(subtotal);

      // 3. Panier vide ou sous seuil → retirer toute protection et cacher
      if (!targetVariant) {
        var protectionItems = cart.items.filter(isProtectionItem);
        hideWidget();
        if (protectionItems.length === 0) { busy = false; return; }

        var chain = Promise.resolve();
        protectionItems.forEach(function(item) {
          chain = chain.then(function() { return removeByKey(item.key); });
        });
        chain.then(function() { busy = false; dispatchCartChanged(); });
        return;
      }

      // 4. Au-dessus du seuil : dédupliquer d'abord
      deduplicateProtection(cart, null, function(protectionItem) {
        showWidget();
        updatePrice(targetVariant.price);

        if (protectionItem) {
          setToggle(true);
          setDeclined(false);

          // Bon variant ?
          if (protectionItem.variant_id !== targetVariant.variantId) {
            // Swap : retirer l'ancienne et ajouter la bonne
            removeByKey(protectionItem.key)
              .then(function() { return addProtection(targetVariant.variantId); })
              .then(function() { busy = false; dispatchCartChanged(); });
          } else {
            busy = false;
          }
        } else {
          // Aucune protection dans le panier
          if (isDeclined()) {
            setToggle(false);
            busy = false;
          } else {
            setToggle(true);
            addProtection(targetVariant.variantId)
              .then(function() { busy = false; dispatchCartChanged(); });
          }
        }
      });
    }).catch(function() { busy = false; });
  }

  function dispatchCartChanged() {
    document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false }));
  }

  // ─── Toggle ───────────────────────────────────────────────────

  function onToggleChange(evt) {
    if (busy) { evt.target.checked = !evt.target.checked; return; }

    var checked = evt.target.checked;
    setDeclined(!checked);

    if (checked) {
      busy = true;
      getCart().then(function (cart) {
        // Anti-doublon : vérifier qu'il n'y en a pas déjà une
        var alreadyHas = cart.items.some(isProtectionItem);
        if (alreadyHas) { busy = false; dispatchCartChanged(); return; }

        var subtotal = 0;
        cart.items.forEach(function (i) { if (!isProtectionItem(i)) subtotal += i.final_line_price; });
        var v = getVariantForTotal(subtotal);
        if (!v) { busy = false; return; }
        addProtection(v.variantId).then(function() { busy = false; dispatchCartChanged(); });
      }).catch(function() { busy = false; });
    } else {
      busy = true;
      getCart().then(function (cart) {
        var protectionItems = cart.items.filter(isProtectionItem);
        if (protectionItems.length === 0) { busy = false; return; }
        var chain = Promise.resolve();
        protectionItems.forEach(function(item) {
          chain = chain.then(function() { return removeByKey(item.key); });
        });
        chain.then(function() { busy = false; dispatchCartChanged(); });
      }).catch(function() { busy = false; });
    }
  }

  // ─── Bind & init ─────────────────────────────────────────────

  function bindToggle() {
    var t = document.getElementById('rakk-protection-toggle');
    if (t && !t._rakkBound) {
      t._rakkBound = true;
      t.addEventListener('change', onToggleChange);
    }
  }

  function onCartChanged() {
    setTimeout(function () {
      widget = null;
      bindToggle();
      syncWidget();
    }, 200);
  }

  function init() {
    injectHideCSS();
    bindToggle();
    syncWidget();

    var drawer = document.querySelector('.cart-drawer');
    if (drawer) {
      new MutationObserver(function () {
        widget = null;
        bindToggle();
      }).observe(drawer, { childList: true, subtree: true });
    }

    document.addEventListener('theme:cartchanged', onCartChanged);
    document.addEventListener('theme:open-cart-drawer', function () {
      setTimeout(function () { widget = null; bindToggle(); syncWidget(); }, 100);
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();